export default "__VITE_ASSET__90230f2e__"